import PropTypes from "prop-types";


export let IncorporationPropTypes = PropTypes.shape({
  domicile: PropTypes.string,
  legalForm: PropTypes.string,
  marketability: PropTypes.string,
  forProfit: PropTypes.bool
})